import React, { useContext, useEffect, useState } from "react";
import "./testPerformanceCss.css";
import PerformanceSearchBar from "utilFunctions/shared/PerformanceSearchBar";
import { useLocation } from "react-router-dom";
// import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
// import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import StudentPortfolioMain from "Pages/StudentPortfolio/StudentPortfolioMain";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import {
  BASE_URL,
  MY_BRANCH_STUDENT_LIST,
  STUDENT_SEARCH,
} from "utilFunctions/Constants/urlConstants";
import {
  StudentContextDispatch,
  StudentPerformanceContextDispatch,
} from "Context/StudentContext";
import { OffcanvasHeader, Spinner } from "reactstrap";
import { Offcanvas } from "reactstrap";
import useGlobalSearchContext from "Context/GlobalSearchContext";
// import StudentSearchHistoryMain from "Pages/StudentHistory/StudentSearchHistoryMain";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import { getUrlOfCoceptKundli } from "utilFunctions/Axios/AxiosRequestConfiguration";
export type searchedstudent = {
  [key: string]: any;
  name: string;
  psid: number | string;
  clazz: string;
  stream: string;
  acadToClassMap?: [];
  selectedYear?: {
    value: "";
    label: "";
  } | null;
};

const TestPerformanceCommentHome = () => {
  const location = useLocation();
  const { state } = location;
  const { globalSearchData, saveGlobalSearchData } = useGlobalSearchContext();
  const studentinfoDispatch = useContext<any>(StudentContextDispatch);
  const studentPerformanceInfoDispatch = useContext<any>(
    StudentPerformanceContextDispatch
  );
  console.log(location, state, "useLocation", globalSearchData);
  const { screen }: any = useWindowSize();
  const [psid, setpsid] = useState<any>(null);
  const [kundaliUrl, setKundaliUrl] = useState<any>(null);
  const [isPerformanceVisible, setIsPerformanceVisible] =
    useState<boolean>(false);
  const { makeRequest: GetStudentData, loading: isStudentLoader } = useGetApi(
    (res) => {
      if (
        res.data &&
        res.data["basicDetails"] &&
        res.data["basicDetails"].length
      ) {
        const studentDetailDetail = {
          selectedStudent: res.data["basicDetails"][0],
          lopDetails: res.data["lopDetails"],
          allBasicDetails: res.data["basicDetails"],
        };
        studentinfoDispatch(studentDetailDetail);
      } else {
        studentinfoDispatch({});
        // setpsid(null);
        // setIsPerformanceVisible(true);
      }
    },
    (error) => {
      console.log(error);
    }
  );
  const { makeRequest: GetSearchData } = useGetApi(
    (data) => {
      const studentAcadYearMap: any = [];
      const new_student = data["data"][0].academicYears;
      if (new_student && Array.isArray(new_student)) {
        new_student.map((el: any) =>
          studentAcadYearMap.push({ label: el, value: el })
        );
      }
      const studentDetailDetail = {
        selectedStudent: {
          ...data["data"][0],
          acadToClassMap: studentAcadYearMap,
        },
        lopDetails: null,
        allBasicDetails: [],
      };
      studentPerformanceInfoDispatch(studentDetailDetail);
      // setpsid(psid);
      // setIsPerformanceVisible(false);
    },
    (error) => {
      studentPerformanceInfoDispatch({});
      console.log("datata====", error);
    }
  );

  useEffect(() => {
    studentinfoDispatch({});
    studentPerformanceInfoDispatch({});
    const psid =
      location.pathname.split("/")[location.pathname.split("/").length - 1] ||
      null;
    if (psid === "performance") {
      setpsid(null);
      setIsPerformanceVisible(true);
    } else {
      if (psid != null) {
        setpsid(psid);
        // NEW api
        GetStudentData(`${BASE_URL + MY_BRANCH_STUDENT_LIST}/${psid}`);

        // Search API
        GetSearchData(`${BASE_URL + STUDENT_SEARCH}psid=${psid}`);
        //getKundalidata
        getUrlOfCoceptKundli(psid, setKundaliUrl);
        setIsPerformanceVisible(false);
      }
    }
  }, [location]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    document.body.classList.add("noOverflow");
    return () => {
      document.body.classList.remove("noOverflow");
    };
  }, []);
  const onRequestClose = () => {
    console.log("onRequestClose");
    saveGlobalSearchData({
      pathurl: null,
      isBranchHealth: false,
      isStudentHealth: false,
      isPerformance: false,
    });
  };
  return (
    <>
      <div
        className={
          ["xxl", "xl", "lg"].includes(screen)
            ? "mainContainerOfPerformance"
            : "mainContainerOfPerformanceMB"
        }
      >
        <Offcanvas
          backdrop={true}
          className="w-100 filterSlider"
          isOpen={globalSearchData?.isPerformance}
          direction="end"
          toggle={onRequestClose}
        >
          <OffcanvasHeader className="filterHeader w-100"></OffcanvasHeader>
        </Offcanvas>
        {isPerformanceVisible && ["xxl", "xl", "lg"].includes(screen) && (
          <PerformanceSearchBar
            isPerformanceVisible={isPerformanceVisible}
            setIsPerformanceVisible={setIsPerformanceVisible}
            mode="performance"
          ></PerformanceSearchBar>
        )}
        {psid != null ? (
          <>
            {isStudentLoader ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner color="info"></Spinner>
              </div>
            ) : (
              <StudentPortfolioMain
                isPerformanceVisible={isPerformanceVisible}
                setIsPerformanceVisible={setIsPerformanceVisible}
                kundaliUrl={kundaliUrl}
              />
            )}
          </>
        ) : (
          <div className="noSearchStudentDataDiv">
            <NoResultFoundSearch
              primaryMessage="Search student"
              secondaryMessage="to check student performance"
            >
              <NoDataFoundIcon />
            </NoResultFoundSearch>
          </div>
        )}
      </div>
    </>
  );
};
export default TestPerformanceCommentHome;
